import React, { useEffect, useState } from 'react';
import { API } from '../../../config/API';
import axios from 'axios';
import styles from '../Signup/Signup.module.css'
import signupLogo from '../../../assets/main-logo.png'
import signupImg from '../../../assets/Landing/signup_img.png'
import { FaArrowLeft, FaChevronLeft, FaTimes } from "react-icons/fa6";
import { Link } from 'react-router-dom/cjs/react-router-dom';
import Loader from '../../../components/Loader/Loader';
import { MdOutlineInfo } from "react-icons/md";
import { Tooltip } from 'bootstrap/dist/js/bootstrap.esm.min.js';

export default function Signup() {
  const [form, setForm] = useState({
    name: '',
    organisationName: '',
    email: '',
    comments: '',
    empId: '',
    uniqueCode: '', // Replace with actual company code if needed
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    // Always assign uniqueCode as uppercase of first 3 chars
    // const submitData = {
    //   ...form,
    //   uniqueCode: `${form.organisationName.substring(0, 3).toUpperCase()}_ORG`
    // };
    // setMessage('');

    try {
      const response = await axios.post(API.signup, form);
      if (response.status === 200) {
        const data = response.data;
        console.log(data);
        // Assuming the API returns a success message or status
        if (data.status === "S") {
          setMessage('Signup successful! Please check your email for confirmation.');
        } else {
          setMessage('Signup failed. Please try again.');
        }
        setForm({ name: '', organisationName: '', email: '', comments: '', empId: '' }); // Reset form fields
      } else {
        setMessage('Signup failed. Please try again.');
      }
    } catch (error) {
      setMessage('An error occurred. Please try again.');
    }
    setLoading(false);
  };

  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new Tooltip(tooltipTriggerEl);
    });
  }, []);

  return (
    <div>
      <Loader loading={loading} />
      <div className='container-fluid'>
        <div className={styles.signup_section}>
          <div className={`row ${styles.signup_card_wrapper}`}>
            <div className='col-lg-6 col-md-6 col-sm-12 pe-5'>
              <div className={styles.signup_img_container}>
                {/* <Link to='/landing'>
                  <button className={styles.back_btn}>
                    <span><FaChevronLeft /></span>Back
                  </button>
                </Link> */}
                <img src={signupImg} alt='' />
              </div>
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12'>
              <div className={styles.signup_form_container}>
                  <Link to='/' className={styles.close_btn} aria-label="Close signup">
                    <FaArrowLeft />
                  </Link>
                <div className={styles.sigup_form_header}>
                  <div className={styles.header_img_wrapper}>
                    <img src={signupLogo} alt='' />
                  </div>
                  <div className={styles.header_text}>
                    <h3>Sign up</h3>
                    <p>Let’s get you all st up so you can access your personal account.</p>
                  </div>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12'>
                      <div className={styles.signup_form_field}>
                        <label>Name:</label><br />
                        <input
                          type="text"
                          name="name"
                          value={form.name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12'>
                      <div className={styles.signup_form_field}>
                        <label>Organization Name:</label><br />
                        <input
                          type="text"
                          name="organisationName"
                          value={form.organisationName}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12'>
                      <div className={styles.signup_form_field}>
                        <label>Email:</label><br />
                        <input
                          type="email"
                          name="email"
                          value={form.email}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12'>
                      <div className={styles.signup_form_field}>
                        <label>Emp ID:</label><br />
                        <input
                          type="text"
                          name="empId"
                          value={form.empId}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12'>
                      <div className={styles.signup_form_field}>
                        <label>Organization Code:</label>
                        <span 
                          data-bs-toggle="tooltip" 
                          data-bs-placement="right" 
                          title="Code must be exactly 4 characters."
                        ><MdOutlineInfo /></span><br />
                        <input
                          type="text"
                          name="uniqueCode"
                          value={form.uniqueCode}
                          onChange={handleChange}
                          maxLength={4}
                          title="Code must be exactly 4 letters or numbers"
                          required
                        />
                      </div>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12'>
                      <div className={styles.signup_form_field}>
                        <label>Comments:</label><br />
                        <textarea
                          name="comments"
                          value={form.comments}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <button type="submit" disabled={loading} className={styles.signup_btn}>
                    {loading ? 'Submitting...' : 'Submit'}
                  </button>
                </form>
                {message && <div>{message}</div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
